import jwtDecode from "jwt-decode";
import { verify, sign } from "jsonwebtoken";
import axios from "./axios";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const isTokenExpired = (accessToken) => {
  const decoded = jwtDecode(accessToken);
  const expire = new Date(decoded.exp * 1000);
  const currentTime = new Date();
  return currentTime > expire;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

const setImpersonationSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("impersonationToken", accessToken);
  } else {
    localStorage.removeItem("impersonationToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

export {
  verify,
  sign,
  isValidToken,
  setSession,
  setImpersonationSession,
  isTokenExpired,
};
